import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  Grid,
  Paper,
  Box,
  Button,
  IconButton,
} from '@material-ui/core';
import DisplayMessages from './DisplayMessages';
import TypeMessageField from './TypeMessageField';
import { CloseIcon } from '@material-ui/data-grid';
import MinimizeIcon from '@material-ui/icons/Minimize';
import { apiGet, getAccessToken, wsUrl } from '../../api/client';

export default function ChatRoom(props) {
  const [chatWith, setChatWith] = useState(localStorage.getItem('chatWith'));
  const chatWithName = localStorage.getItem('chatWithName');
  const userId = localStorage.getItem('userId');
  const userName = JSON.parse(localStorage.getItem('userName') || '{}');
  const [messages, setMessages] = useState([]);
  const [height, setHeight] = useState(
    localStorage.getItem('chatBoxHeight') || '450px'
  );
  const messagesEndRef = useRef(null);
  const socketRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'auto' });
  };

  useEffect(() => {
    chatWith && scrollToBottom();
  }, [messages, height, chatWith]);

  useEffect(() => {
    if (!chatWith) return;
    apiGet(`/conversations/${chatWith}/messages`)
      .then(({ data }) => setMessages(data.data || []))
      .catch((err) => {
        alert(`ERR: ${err.message || err}`);
      });

    if (!getAccessToken()) return;
    const ws = new WebSocket(wsUrl());
    socketRef.current = ws;
    ws.onmessage = (event) => {
      const reply = JSON.parse(event.data);
      if (reply.type === 'message' && reply.senderId == chatWith) {
        setMessages((prev) => [...prev, reply]);
      }
    };
    return () => ws.close();
  }, [chatWith]);

  const sendMessage = (msg) => {
    if (msg.trim() === '' || !socketRef.current) return;
    const payload = {
      type: 'message',
      recipientId: Number(chatWith),
      content: msg,
    };
    socketRef.current.send(JSON.stringify(payload));
    setMessages((prev) => [
      ...prev,
      {
        type: 'message',
        senderId: String(userId),
        recipientId: String(chatWith),
        senderName: userName.fname,
        content: msg,
        timestamp: new Date().toISOString(),
      },
    ]);
  };

  return chatWith ? (
    <Paper
      style={{
        position: 'fixed',
        bottom: 0,
        right: '2%',
        height: height,
        width: '310px',
        bordertopLeftRadius: '7px',
        borderTopRightRadius: '7px',
        overflow: 'hidden',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Grid
        container
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Grid
          container
          justify="space-between"
          alignItems="center"
          style={{
            backgroundColor: '#f5802c',
            color: '#fff',
            padding: '8px',
          }}
        >
          <Typography>{chatWithName}</Typography>
          <Box>
            <IconButton
              size="small"
              onClick={() =>
                setHeight(height === '450px' ? '60px' : '450px')
              }
            >
              <MinimizeIcon style={{ color: '#fff' }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                localStorage.removeItem('chatWith');
                localStorage.removeItem('chatWithName');
                setChatWith(null);
              }}
            >
              <CloseIcon style={{ color: '#fff' }} />
            </IconButton>
          </Box>
        </Grid>
        <Box style={{ flex: 1, overflowY: 'auto', padding: 8 }}>
          <DisplayMessages messages={messages} userId={userId} />
          <div ref={messagesEndRef} />
        </Box>
        <TypeMessageField sendMessage={sendMessage} />
      </Grid>
    </Paper>
  ) : null;
}
